import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const ResetPassword = () => {
    return (
        <>
            <Header as="h1" id="reset-header">Reset Password</Header>
        </>
    );
};

export default ResetPassword;